module.exports = function () {
    'use strict';
    function ZoomController(peaks, zoomLevels) {
        this._peaks = peaks;
        this._zoomLevels = zoomLevels;
        this._zoomLevelIndex = 0;
    }
    ZoomController.prototype.setZoomLevels = function (zoomLevels) {
        this._zoomLevels = zoomLevels;
        this.setZoom(0, true);
    };
    ZoomController.prototype.zoomIn = function () {
        this.setZoom(this._zoomLevelIndex - 1);
    };
    ZoomController.prototype.zoomOut = function () {
        this.setZoom(this._zoomLevelIndex + 1);
    };
    ZoomController.prototype.setZoom = function (zoomLevelIndex, forceUpdate) {
        if (zoomLevelIndex >= this._zoomLevels.length) {
            zoomLevelIndex = this._zoomLevels.length - 1;
        }
        if (zoomLevelIndex < 0) {
            zoomLevelIndex = 0;
        }
        if (!forceUpdate && zoomLevelIndex === this._zoomLevelIndex) {
            return;
        }
        this._zoomLevelIndex = zoomLevelIndex;
        var zoomview = this._peaks.views.getView('zoomview');
        if (!zoomview) {
            return;
        }
        zoomview.setZoom({ scale: this._zoomLevels[zoomLevelIndex] });
    };
    ZoomController.prototype.getZoom = function () {
        return this._zoomLevelIndex;
    };
    ZoomController.prototype.getZoomLevel = function () {
        return this._zoomLevels[this._zoomLevelIndex];
    };
    return ZoomController;
}();